export const USER_ADD_SUCCESS = 'user/add/success'
export const USER_ADD_FAIL = 'user/add/failed' 
